// import actionType from './actionTypes';
import {
  CREATE_SINGLE_JOB,
  CREATE_SINGLE_JOB_SUCCESS,
  CREATE_SINGLE_JOB_FAILURE,
  READ_SINGLE_JOB,
  READ_SINGLE_JOB_SUCCESS,
  READ_SINGLE_JOB_FAILURE,
  UPDATE_SINGLE_JOB,
  UPDATE_SINGLE_JOB_SUCCESS,
  UPDATE_SINGLE_JOB_FAILURE,
  DELETE_SINGLE_JOB,
  DELETE_SINGLE_JOB_SUCCESS,
  DELETE_SINGLE_JOB_FAILURE,
  READ_SINGLE_JOB_NOTES_LIST,
  READ_SINGLE_JOB_NOTES_LIST_SUCCESS,
  READ_SINGLE_JOB_NOTES_LIST_FAILURE,
  READ_SINGLE_JOB_NOTE,
  READ_SINGLE_JOB_NOTE_SUCCESS,
  READ_SINGLE_JOB_NOTE_FAILURE,
  CREATE_SINGLE_JOB_NOTE,
  CREATE_SINGLE_JOB_NOTE_SUCCESS,
  CREATE_SINGLE_JOB_NOTE_FAILURE,
  GET_JOB_TIME_ENTRY_LIST,
  GET_JOB_TIME_ENTRY_LIST_SUCCESS,
  GET_JOB_TIME_ENTRY_LIST_FAILURE,
  CREATE_JOB_TIME_ENTRY,
  CREATE_JOB_TIME_ENTRY_SUCCESS,
  CREATE_JOB_TIME_ENTRY_FAILURE,
  GET_SINGLE_JOB_ATTACHMENT_LIST,
  GET_SINGLE_JOB_ATTACHMENT_LIST_SUCCESS,
  GET_SINGLE_JOB_ATTACHMENT_LIST_FAILURE,
  GET_SINGLE_JOB_RECENT_ACTIVITY_LIST,
  GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_FAILURE,
  GET_SINGLE_JOB_ATTACHMENT_URL,
  GET_SINGLE_JOB_ATTACHMENT_URL_SUCCESS,
  GET_SINGLE_JOB_ATTACHMENT_URL_FAILURE,
  GET_SINGLE_JOB_DETAILS_FOR_TIMER,
  GET_SINGLE_JOB_DETAILS_FOR_TIMER_SUCCESS,
  GET_SINGLE_JOB_DETAILS_FOR_TIMER_FAILURE,
  GET_BILLABLE_JOB_ITEMS_LIST,
  GET_BILLABLE_JOB_ITEMS_LIST_SUCCESS,
  GET_BILLABLE_JOB_ITEMS_LIST_FAILURE,
  GET_BILLABLE_JOB_ITEM_DETAILS,
  GET_BILLABLE_JOB_ITEM_DETAILS_SUCCESS,
  GET_BILLABLE_JOB_ITEM_DETAILS_FAILURE,
  CREATE_BILLABLE_JOB_ITEM,
  CREATE_BILLABLE_JOB_ITEM_SUCCESS,
  CREATE_BILLABLE_JOB_ITEM_FAILURE,
  UPDATE_BILLABLE_JOB_ITEM,
  UPDATE_BILLABLE_JOB_ITEM_SUCCESS,
  UPDATE_BILLABLE_JOB_ITEM_FAILURE,
  DELETE_BILLABLE_JOB_ITEM,
  DELETE_BILLABLE_JOB_ITEM_SUCCESS,
  DELETE_BILLABLE_JOB_ITEM_FAILURE,
} from "./actionType";

// ***** Single Job CRUD Action Creators *****

// Create Single Job
export const createSingleJob = (job) => ({
  type: CREATE_SINGLE_JOB,
  payload: job,
});

// Create Single Job Success
export const createSingleJobSuccess = (job) => ({
  type: CREATE_SINGLE_JOB_SUCCESS,
  payload: job,
});

// Create Single Job Failure
export const createSingleJobFailure = (error) => ({
  type: CREATE_SINGLE_JOB_FAILURE,
  payload: error,
});

// Read Single Job
export const readSingleJob = (jobId) => ({
  type: READ_SINGLE_JOB,
  payload: jobId,
});

// Read Single Job Success

export const readSingleJobSuccess = (job) => ({
  type: READ_SINGLE_JOB_SUCCESS,
  payload: job,
});

// Read Single Job Failure

export const readSingleJobFailure = (error) => ({
  type: READ_SINGLE_JOB_FAILURE,
  payload: error,
});

// Update Single Job

export const updateSingleJob = (job) => ({
  type: UPDATE_SINGLE_JOB,
  payload: job,
});

// Update Single Job Success

export const updateSingleJobSuccess = (job) => ({
  type: UPDATE_SINGLE_JOB_SUCCESS,
  payload: job,
});

// Update Single Job Failure

export const updateSingleJobFailure = (error) => ({
  type: UPDATE_SINGLE_JOB_FAILURE,
  payload: error,
});

// Delete Single Job

export const deleteSingleJob = (jobId) => ({
  type: DELETE_SINGLE_JOB,
  payload: jobId,
});

// Delete Single Job Success

export const deleteSingleJobSuccess = (jobId) => ({
  type: DELETE_SINGLE_JOB_SUCCESS,
  payload: jobId,
});

// Delete Single Job Failure

export const deleteSingleJobFailure = (error) => ({
  type: DELETE_SINGLE_JOB_FAILURE,
  payload: error,
});

// ***** Single Job Notes CRUD* Action Creators *****

// Read Single Job Notes List

export const readSingleJobNotesList = (job) => ({
  type: READ_SINGLE_JOB_NOTES_LIST,
  payload: job,
});

// Read Single Job Notes List Success

export const readSingleJobNotesListSuccess = (notes) => ({
  type: READ_SINGLE_JOB_NOTES_LIST_SUCCESS,
  payload: notes,
});

// Read Single Job Notes List Failure

export const readSingleJobNotesListFailure = (error) => ({
  type: READ_SINGLE_JOB_NOTES_LIST_FAILURE,
  payload: error,
});

// Read Single Job Note

export const readSingleJobNote = (noteId) => ({
  type: READ_SINGLE_JOB_NOTE,
  payload: noteId,
});

// Read Single Job Note Success

export const readSingleJobNoteSuccess = (note) => ({
  type: READ_SINGLE_JOB_NOTE_SUCCESS,
  payload: note,
});

// Read Single Job Note Failure

export const readSingleJobNoteFailure = (error) => ({
  type: READ_SINGLE_JOB_NOTE_FAILURE,
  payload: error,
});

// Create Single Job Note

export const createSingleJobNote = (note) => ({
  type: CREATE_SINGLE_JOB_NOTE,
  payload: note,
});

// Create Single Job Note Success

export const createSingleJobNoteSuccess = (note) => ({
  type: CREATE_SINGLE_JOB_NOTE_SUCCESS,
  payload: note,
});

// Create Single Job Note Failure

export const createSingleJobNoteFailure = (error) => ({
  type: CREATE_SINGLE_JOB_NOTE_FAILURE,
  payload: error,
});

// ***** Single Job Notes CRUD* Action Creators *****

// ***** Get Job Time Entry List Action Creators *****
export const getJobTimeEntryList = (job_id) => ({
  type: GET_JOB_TIME_ENTRY_LIST,
  payload: job_id,
});

export const getJobTimeEntryListSuccess = (timeEntries) => ({
  type: GET_JOB_TIME_ENTRY_LIST_SUCCESS,
  payload: timeEntries,
});

export const getJobTimeEntryListFailure = (error) => ({
  type: GET_JOB_TIME_ENTRY_LIST_FAILURE,
  payload: error,
});

// ***** Create Job Time Entry Action Creators *****
export const createJobTimeEntry = (data) => ({
  type: CREATE_JOB_TIME_ENTRY,
  payload: data,
});

export const createJobTimeEntrySuccess = (data) => ({
  type: CREATE_JOB_TIME_ENTRY_SUCCESS,
  payload: data,
});

export const createJobTimeEntryFailure = (error) => ({
  type: CREATE_JOB_TIME_ENTRY_FAILURE,
  payload: error,
});

// ***** Get Single Job Attachment List Action Creators *****
export const getSingleJobAttachmentList = (job_id) => ({
  type: GET_SINGLE_JOB_ATTACHMENT_LIST,
  payload: job_id,
});

export const getSingleJobAttachmentListSuccess = (attachments) => ({
  type: GET_SINGLE_JOB_ATTACHMENT_LIST_SUCCESS,
  payload: attachments,
});

export const getSingleJobAttachmentListFailure = (error) => ({
  type: GET_SINGLE_JOB_ATTACHMENT_LIST_FAILURE,
  payload: error,
});

// ***** Get Single Job Recent Activity List Action Creators *****
export const getSingleJobRecentActivityList = (job_id) => ({
  type: GET_SINGLE_JOB_RECENT_ACTIVITY_LIST,
  payload: job_id,
});

export const getSingleJobRecentActivityListSuccess = (recentActivity) => ({
  type: GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_SUCCESS,
  payload: recentActivity,
});

export const getSingleJobRecentActivityListFailure = (error) => ({
  type: GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_FAILURE,
  payload: error,
});

// ***** Get Single Job Attachment URL Action Creators *****
export const getSingleJobAttachmentURL = (attachment_id) => ({
  type: GET_SINGLE_JOB_ATTACHMENT_URL,
  payload: attachment_id,
});

export const getSingleJobAttachmentURLSuccess = (attachmentURL) => ({
  type: GET_SINGLE_JOB_ATTACHMENT_URL_SUCCESS,
  payload: attachmentURL,
});

export const getSingleJobAttachmentURLFailure = (error) => ({
  type: GET_SINGLE_JOB_ATTACHMENT_URL_FAILURE,
  payload: error,
});

// ***** Get Single Job Details For Timer Action Creators *****
export const getSingleJobDetailsForTimer = (job_id) => ({
  type: GET_SINGLE_JOB_DETAILS_FOR_TIMER,
  payload: job_id,
});

export const getSingleJobDetailsForTimerSuccess = (jobDetails) => ({
  type: GET_SINGLE_JOB_DETAILS_FOR_TIMER_SUCCESS,
  payload: jobDetails,
});

export const getSingleJobDetailsForTimerFailure = (error) => ({
  type: GET_SINGLE_JOB_DETAILS_FOR_TIMER_FAILURE,
  payload: error,
});

// ***** Billable Job Items List Action Creators *****
export const getBillableJobItemsList = (job_id) => ({
  type: GET_BILLABLE_JOB_ITEMS_LIST,
  payload: job_id,
});

export const getBillableJobItemsListSuccess = (billableJobItems) => ({
  type: GET_BILLABLE_JOB_ITEMS_LIST_SUCCESS,
  payload: billableJobItems,
});

export const getBillableJobItemsListFailure = (error) => ({
  type: GET_BILLABLE_JOB_ITEMS_LIST_FAILURE,
  payload: error,
});

// ***** Billable Job Item Details Action Creators *****
export const getBillableJobItemDetails = (billableJobItem_id) => ({
  type: GET_BILLABLE_JOB_ITEM_DETAILS,
  payload: billableJobItem_id,
});

export const getBillableJobItemDetailsSuccess = (billableJobItem) => ({
  type: GET_BILLABLE_JOB_ITEM_DETAILS_SUCCESS,
  payload: billableJobItem,
});

export const getBillableJobItemDetailsFailure = (error) => ({
  type: GET_BILLABLE_JOB_ITEM_DETAILS_FAILURE,
  payload: error,
});

// ***** Create Billable Job Item Action Creators *****
export const createBillableJobItem = (billableJobItem) => ({
  type: CREATE_BILLABLE_JOB_ITEM,
  payload: billableJobItem,
});

export const createBillableJobItemSuccess = (billableJobItem) => ({
  type: CREATE_BILLABLE_JOB_ITEM_SUCCESS,
  payload: billableJobItem,
});

export const createBillableJobItemFailure = (error) => ({
  type: CREATE_BILLABLE_JOB_ITEM_FAILURE,
  payload: error,
});

// ***** Update Billable Job Item Action Creators *****
export const updateBillableJobItem = (billableJobItem) => ({
  type: UPDATE_BILLABLE_JOB_ITEM,
  payload: billableJobItem,
});

export const updateBillableJobItemSuccess = (billableJobItem) => ({
  type: UPDATE_BILLABLE_JOB_ITEM_SUCCESS,
  payload: billableJobItem,
});

export const updateBillableJobItemFailure = (error) => ({
  type: UPDATE_BILLABLE_JOB_ITEM_FAILURE,
  payload: error,
});

// ***** Delete Billable Job Item Action Creators *****
export const deleteBillableJobItem = (billableJobItem_id) => ({
  type: DELETE_BILLABLE_JOB_ITEM,
  payload: billableJobItem_id,
});

export const deleteBillableJobItemSuccess = (billableJobItem_id) => ({
  type: DELETE_BILLABLE_JOB_ITEM_SUCCESS,
  payload: billableJobItem_id,
});

export const deleteBillableJobItemFailure = (error) => ({
  type: DELETE_BILLABLE_JOB_ITEM_FAILURE,
  payload: error,
});
